import { DataFormatted } from './ScheduleAppointment.types'

export const INITIAL_CLINIC_DATA = { id: null, name: '' }

export const INITIAL_PATIENT_DATA = {
  patientCpf: '',
  patientId: null,
  patientName: '',
  patientEmail: '',
  patientPhone: '',
}

export const INITIAL_OBJECTIVE_DATA = {
  id: null,
  key: null,
  value: '',
}

export const INITIAL_DATA_FORMATTED_DATA: DataFormatted = {
  appointmentObjectiveKey: null,
  fitIn: 'false',
  page: null,
  patient: null,
  professional: null,
  professionalTypeKey: null,
  specialtyId: null,
  startDate: null,
  healthInsurance: null,
}

export const INITIAL_SCHEDULE_LIST_DATA = {
  total: 0,
  data: [],
}

export const INITIAL_HEALTH_INSURANCE_DATA = {
  id: null,
  healthInsuranceNumber: '',
  healthInsuranceId: null,
  multipleHealthInsuranceCards: false,
}

export const INITIAL_DATA = {
  key: null,
  value: '',
}
